import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
`;

const LoaderItem = styled.span`
  display: block;
  width: var(--size-spacing-02);
  height: var(--size-spacing-02);
  border-radius: var(--border-radius-circle);
  background: var(--primary-icon);
  animation: ${bounce} 1s infinite;
`;

const LoaderContainer = styled.div`
  display: flex;
  gap: var(--size-spacing-01);

  ${LoaderItem}:nth-child(2) {
    animation-delay: 300ms;
  }
`;

export const Loader = () => {
  return (
    <LoaderContainer>
      <LoaderItem />
      <LoaderItem />
      <LoaderItem />
    </LoaderContainer>
  );
};
